module.exports = __webpack_public_path__ + "media/Video 1b.028841b7.mp4";